var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.995,
    height: 25.995,
    viewBox: "0 0 25.995 25.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,1.8a.8.8,0,0,1,.8-.8h.4a.8.8,0,0,1,.8.8V4.2a.8.8,0,0,1-.8.8h-.4a.8.8,0,0,1-.8-.8Z",
    transform: "translate(-0.002)",
    fill: "#7ec1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,21a7,7,0,1,0-7-7A7,7,0,0,0,14,21Zm0-2a5,5,0,1,0-5-5A5,5,0,0,0,14,19Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#7ec1ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,13.8a.8.8,0,0,0-.8-.8H1.8a.8.8,0,0,0-.8.8v.4a.8.8,0,0,0,.8.8H4.2a.8.8,0,0,0,.8-.8Z",
    transform: "translate(0 -0.002)",
    fill: "#7ec1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,13a.8.8,0,0,1,.8.8v.4a.8.8,0,0,1-.8.8H23.8a.8.8,0,0,1-.8-.8v-.4a.908.908,0,0,1,.019-.181.651.651,0,0,1,.031-.105A.8.8,0,0,1,23.8,13Z",
    transform: "translate(-0.005 -0.002)",
    fill: "#7ec1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.974,4.692a.8.8,0,0,0-1.133,0L20.148,6.386a.868.868,0,0,0-.107.133.83.83,0,0,0-.113.585.827.827,0,0,0,.037.134.584.584,0,0,0,.043.094.8.8,0,0,0,.086.127l.055.059.283.283a.8.8,0,0,0,1.131,0l1.693-1.694a.786.786,0,0,0,.17-.249.794.794,0,0,0,.06-.4.811.811,0,0,0-.23-.484Z",
    transform: "translate(-0.004 -0.001)",
    fill: "#7ec1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.384,7.8a.8.8,0,0,0,1.133,0L7.8,7.516a.8.8,0,0,0,.234-.566.787.787,0,0,0-.08-.351A.832.832,0,0,0,7.8,6.385l-1.7-1.7a.8.8,0,0,0-1.131,0l-.283.282a.8.8,0,0,0-.146.2.825.825,0,0,0-.088.384.791.791,0,0,0,.234.548Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#7ec1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.763,19.915a.8.8,0,0,0-1.133,0l-1.695,1.7a.8.8,0,0,0,0,1.132l.283.283a.8.8,0,0,0,1.131,0l1.695-1.7a.8.8,0,0,0,0-1.131Z",
    transform: "translate(-0.001 -0.004)",
    fill: "#7ec1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.058,23.306a.768.768,0,0,0,.217.021.8.8,0,0,0,.41-.133.924.924,0,0,0,.123-.1l.281-.283a.8.8,0,0,0,0-1.131l-1.7-1.7a.8.8,0,0,0-1.131,0l-.283.282a.8.8,0,0,0,0,1.132l1.7,1.7A.806.806,0,0,0,22.058,23.306Z",
    transform: "translate(-0.004 -0.004)",
    fill: "#7ec1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.205,23.264A.8.8,0,0,0,13,23.8v2.4a.8.8,0,0,0,.8.8h.4a.8.8,0,0,0,.8-.8V23.8a.8.8,0,0,0-.8-.8h-.4A.8.8,0,0,0,13.205,23.264Z",
    transform: "translate(-0.002 -0.005)",
    fill: "#7ec1ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.2de24160.svg";
export { ForwardRef as ReactComponent };